import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Data } from '@angular/router';
import { Observable } from 'rxjs';
import { AgendamentoDto } from '../dtos/agendamentos/agendamento-dto';
import { UrlService } from './url.service';

@Injectable({
  providedIn: 'root'
})
export class AgendamentoService {

  constructor(private http: HttpClient, private url: UrlService) { }

  listarAgendamentos(dataInicial: Date, dataFinal: Date, apenasComAgendamentoVinculado: boolean): Observable<AgendamentoDto[]> {
    let p = new HttpParams();
    
    let filtro = p
    .append('dataInicial', dataInicial.toISOString())
    .append('dataFinal', dataFinal.toISOString())
    .append('apenasComAgendamentoVinculado', apenasComAgendamentoVinculado ? 'true' : 'false');

    return this.http.get<AgendamentoDto[]>(this.url.url('agendamentos'), { params: filtro });
  }

}
